module.exports = "./img/desktop_logo.51f0676.png";